/**
 * Paleta de colores para el módulo Registros de Uso
 * Centraliza todos los colores hardcodeados para facilitar mantenimiento
 */

export const COLORS = {
    // Colores de estado
    success: '#4CAF50',
    warning: '#FF9800',
    error: '#f44336',
    
    // Colores primarios
    primary: '#2196F3',
    primaryDark: '#1976d2',
    primaryLight: '#64B5F6',
    
    // Colores de texto
    textPrimary: '#333',
    textSecondary: '#666',
    textDisabled: '#999',
    
    // Colores de fondo
    backgroundWhite: '#FFFFFF',
    backgroundLight: '#F5F8F9',
    backgroundGray: '#f8f9fa',
    
    // Colores de borde
    borderLight: '#e0e0e0',
    borderMedium: '#d0d0d0',
    borderDark: '#bdbdbd',
    
    // Colores de participación (tabla)
    participationHigh: '#4CAF50',    // >= 80%
    participationMedium: '#FF9800',  // >= 50%
    participationLow: '#F44336',     // < 50%
    
    // Colores de botones
    buttonSuccess: '#4CAF50',
    buttonSuccessHover: '#45a049',
};

export default COLORS;
